/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeLatest } from 'redux-saga/effects'
import { getCrewSelector } from '../selectors'
import { setCrewList, saveCrewListRequest } from '../store/crew.actions'
import { CrewConstants } from '../store/crew.constants'
import { ICrewState } from '../store/crew.types'

export function* setCrewRole() {
  const crew: ICrewState = yield select(getCrewSelector)
  const { crewMember, crewList, roleId, roleIdPNNV, preceptorStudent } = crew

  const selectedCrew = crewList.filter((cl) => cl.key === crewMember?.key)
  if (selectedCrew && selectedCrew.length) {
    selectedCrew[0].roleId = roleId
    selectedCrew[0].roleIdPNNV = roleIdPNNV
    selectedCrew[0].preceptorStudent = preceptorStudent
  }
  yield put(setCrewList(crewList))
  yield put(saveCrewListRequest(crewList))
}

export function* setRoleSaga() {
  yield takeLatest(
    [CrewConstants.SET_ROLE, CrewConstants.SET_ROLE_PNNV, CrewConstants.SET_PRECEPTOR_STUDENT],
    setCrewRole
  )
}
